import { useContext } from 'react';
import { InputFile } from '../components'
import { DataContext } from '../data/DataContext';

const StepUsedCarFile = () => {
    const { AutoEmisionCR, setAutoEmisionCR } = useContext(DataContext);
    const changeFiles = (propierties: string, files: Array<File>, isMod: boolean) => setAutoEmisionCR({ ...AutoEmisionCR, [propierties]: files, [`${propierties}IsModified`]: isMod });

    return <>
        <InputFile
            id='frontCarImage'
            label='Favor adjuntar fotos del frente'
            files={AutoEmisionCR.frontCarImage}
            onChange={changeFiles}
            maxFiles={2}
        />
        <InputFile
            id='backCarImage'
            label='Favor adjuntar fotos de atrás'
            files={AutoEmisionCR.backCarImage}
            onChange={changeFiles}
            maxFiles={2}
        />
        <InputFile
            id='rightSideCarImage'
            label='Favor adjuntar fotos derecha'
            files={AutoEmisionCR.rightSideCarImage}
            onChange={changeFiles}
            maxFiles={2}
        />
        <InputFile
            id='leftSideCarImage'
            label='Favor adjuntar fotos izquierda'
            files={AutoEmisionCR.leftSideCarImage}
            onChange={changeFiles}
            maxFiles={2}
        />
        <InputFile
            id='carPanelImage'
            label='Favor adjuntar fotos panel (tacómetro) encendido'
            files={AutoEmisionCR.carPanelImage}
            onChange={changeFiles}
            maxFiles={2}
        />
    </>
}

export { StepUsedCarFile }